<template>
	<div class="drawer">
		<el-drawer
		size="400px"
		:visible.sync="drawerStatus"
		@close='handleClose'
		:title="'修改订金金额'"
		:append-to-body="true"
		>
			<el-form :inline="true" class="form">
				<el-row style="padding:10px 10px;float: none;">
					<el-col :span="24">
						<span style="color:red;padding-left:58px;font-size: 14px;">订金金额不能低于1000元</span>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="24">
							<el-form-item label="订金:" :label-width="formLabelWidth">
								<el-input v-model="num" @input="inputNum" style="width:300px;" placeholder="请输入订金" size="small"></el-input>
							</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">生成订单</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'60px',
				num:'',
			}
		},
		props:{
			money:{
				default:''
			}
		},
		mounted(){
			this.num = this.money;
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			inputNum(){
				this.num = this.$public.replaceGoodsDosage(this.num)
			},
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submitCode(){
				if(this.$public.isNull(this.num)||Number(this.num)<1000){
					this.$message({
						message: '订金必须大于1000元！',
						type: 'error'
					});
					return 
				}
				this.$emit('submit',{type:'success',data:this.num})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
				}
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
